import { http } from '../../../http-common';

export interface ControlAreaPayload {
  name: string;
  isActive?: boolean;
  isOther?: boolean;
  attributeIds?: number[];
}

export interface ControlAreaAttribute {
  id: number;
  name?: string;
}

export interface ControlAreaResponse extends ControlAreaPayload {
  id: number;
  attributes?: ControlAreaAttribute[];
}

const basePath = '/control-areas';

const listControlAreas = (isActive?: boolean) =>
  http.get<ControlAreaResponse[]>(basePath, {
    params: typeof isActive === 'boolean' ? { isActive } : undefined,
  });

const createControlArea = (data: ControlAreaPayload) => http.post(basePath, data);

const updateControlArea = (id: number, data: ControlAreaPayload) => http.put(`${basePath}/${id}`, data);

const deleteControlArea = (id: number) => http.delete(`${basePath}/${id}`);

const ControlAreaService = {
  listControlAreas,
  createControlArea,
  updateControlArea,
  deleteControlArea,
};

export default ControlAreaService;
